<template>
	<Bar :data="data" :options="options" :height="height"/>
</template>

<script>
import {Chart as ChartJS, Title, Tooltip, Legend, BarController, CategoryScale, LinearScale, PointElement} from "chart.js";
import { BarElement } from 'chart.js';
import { Bar } from "vue-chartjs";

ChartJS.register(Title, Tooltip, Legend, BarController, CategoryScale, LinearScale, PointElement, BarElement);

export default {
	name: "BarChart",
	components: {
		Bar,
	},
	props: {
		data: {
			type: Object,
			default: () => {
				return {};
			},
		},
		options: {
			type: Object,
			default: () => {
				return {};
			},
		},
		height: {
			type: String,
			default: "",
		},
	},
};
</script>
